import { render, staticRenderFns } from "./solveIndex.vue?vue&type=template&id=6d3fca4b&scoped=true&"
import script from "./solveIndex.vue?vue&type=script&lang=js&"
export * from "./solveIndex.vue?vue&type=script&lang=js&"
import style0 from "./solveIndex.vue?vue&type=style&index=0&id=6d3fca4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3fca4b",
  null
  
)

export default component.exports